import React, { useContext, useState } from "react";
import Button from "@mui/material/Button";
import {
  BACKGROUND_GRAY,
  GREEN_40,
  SUBMIT_BUTTON_STYLES,
} from "../../../constants/css.constants";
import { IGNORE_SUBMISSION_WINDOW } from "../../../constants/app.constants";
import { AtOnceContext } from "../../../contexts/AtOnceContext";
import { DistributionContext } from "../../../contexts/DistributionContext";
import { FuturesContext } from "../../../contexts/FuturesContext";
import { SeasonToMonthContext } from "../../../contexts/SeasonToMonthContext";
import { ForecastContext } from "../../../contexts/ForecastContext";
import useClient from "../../../hooks/useClient";
import { FORECAST_URI } from "../ShipmentMonthTables/ShipmentMonthTables.constants";
import { Check } from "@mui/icons-material";
import useEditRights from "../../../hooks/useEditRights";
import { useLocation } from "react-router-dom";
import useSubmissionDate from "../../../hooks/useSubmissionDate";

const SaveButton = ({
  queryParams,
  setError,
  tabRef,
}: {
  queryParams: string;
  setError: (text: string) => void;
  tabRef: any;
}) => {
  const { canEdit } = useEditRights();
  const { originalForecast } = useContext(ForecastContext);
  const { distributionData } = useContext(DistributionContext);
  const { atOnceData } = useContext(AtOnceContext);
  const { futuresData } = useContext(FuturesContext);
  const { seasonToMonthData, cupData } = useContext(SeasonToMonthContext);
  const { outsideSubmissionDate } = useSubmissionDate();

  const disabled = (IGNORE_SUBMISSION_WINDOW) ? false : outsideSubmissionDate || !canEdit;
  const [success, setSuccess] = useState(false);
  const { pathname } = useLocation();
  const { putData } = useClient();
  const is3PW = pathname.includes("3pw");

  const lookUp = {
    at_once: atOnceData,
    dist_method: distributionData,
    futures: futuresData,
  };
  if (is3PW) lookUp["history"] = seasonToMonthData;
  const onClick = async () => {
    const updatedForecast = Object.keys(originalForecast).reduce(
      (acc, key) => {
        // Ignore anything that's not user changed data in the lookup
        if (lookUp[key] === undefined)
          return { ...acc, [key]: originalForecast[key] };
        if (originalForecast[key] === null && lookUp[key] !== undefined)
          return {
            ...acc,
            [key]: lookUp[key].map((row) =>
              row.map((val) => (isNaN(val) ? 0 : val)),
            ),
          };
        const forecast = originalForecast[key];
        return {
          ...acc,
          [key]: forecast.map((row, rowIndex) =>
            row.map((_, columnIndex) => {
              const val = lookUp[key][rowIndex][columnIndex];
              return val === undefined || val === null || isNaN(val) ? 0 : val;
            }),
          ),
        };
      },
      {} as typeof originalForecast,
    );
    if (originalForecast.history_LR_totals) {
      const lastRow = cupData.length - 1;
      updatedForecast.history_LR_totals = [
        originalForecast.history_LR_totals[0],
        ...cupData[lastRow].slice(0, cupData[lastRow].length - 3),
      ];
    }
    const result = await putData(
      `${FORECAST_URI}${queryParams}`,
      updatedForecast,
      setError,
    );
    if (result) {
      tabRef.current.style.backgroundColor=GREEN_40;
      setSuccess(true);
      setTimeout(() => {
        setSuccess(false);
      }, 3000);
    }
  };
  return (
    <Button
      style={SUBMIT_BUTTON_STYLES(disabled ? BACKGROUND_GRAY : GREEN_40)}
      variant="contained"
      onClick={onClick}
      size="large"
      disabled={disabled}
    >
      <span style={{ marginRight: "5px" }}>Save</span>
      {success && <Check color={"primary"} />}
    </Button>
  );
};

export default SaveButton;
